function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { BaseThumbnailManager } from './base-thumbnail-manager';
export var GenericThumbnailManager = /*#__PURE__*/ function(BaseThumbnailManager) {
    "use strict";
    _inherits(GenericThumbnailManager, BaseThumbnailManager);
    function GenericThumbnailManager(thumbnailProvider, thumbnailConfig) {
        _class_call_check(this, GenericThumbnailManager);
        var _this;
        _this = _call_super(this, GenericThumbnailManager, [
            thumbnailConfig
        ]), _define_property(_this, "thumbnailProvider", void 0), _define_property(_this, "chosenThumbnailStream", void 0), _define_property(_this, "lastGivenSegment", void 0), _define_property(_this, "liveThumbnailStreamId", void 0), _this.thumbnailProvider = thumbnailProvider, _this.chosenThumbnailStream = null, _this.lastGivenSegment = null;
        return _this;
    }
    _create_class(GenericThumbnailManager, [
        {
            key: "handleThumbnailVariantsInfoAvailable",
            value: function handleThumbnailVariantsInfoAvailable() {
                var thumbnailVariants = this.thumbnailProvider.getThumbnailVariants();
                this.notifyAvailableThumbnailVariantsChanged(thumbnailVariants);
            }
        },
        {
            key: "nativeSetThumbnailVariant",
            value: function nativeSetThumbnailVariant(variantId) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_prefetchController, chosenStream;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.thumbnailProvider.isLive()) {
                                    _this.liveThumbnailStreamId = variantId;
                                    return [
                                        2,
                                        Promise.resolve(true)
                                    ];
                                }
                                return [
                                    4,
                                    _this.thumbnailProvider.getThumbnailStream(variantId)
                                ];
                            case 1:
                                chosenStream = _state.sent();
                                if (!chosenStream) {
                                    return [
                                        2,
                                        Promise.resolve(false)
                                    ];
                                }
                                _this.chosenThumbnailStream = chosenStream;
                                _this.chosenStreamSegments = chosenStream.thumbnailSegments;
                                (_this_prefetchController = _this.prefetchController) === null || _this_prefetchController === void 0 ? void 0 : _this_prefetchController.handleThumbnailStreamSelected(chosenStream);
                                return [
                                    2,
                                    Promise.resolve(true)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "nativeGetThumbnailForTime",
            value: function nativeGetThumbnailForTime(timeIncludingAds, contentTime) {
                var _this = this;
                return _async_to_generator(function() {
                    var segment;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSegmentForTime(timeIncludingAds)
                                ];
                            case 1:
                                segment = _state.sent();
                                if (!segment) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                return [
                                    2,
                                    {
                                        url: segment.tileUrl,
                                        startPosition: segment.startPosition,
                                        duration: segment.duration,
                                        boundingRect: _this.buildBoundingRect(timeIncludingAds, segment)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "nativeDestroy",
            value: function nativeDestroy() {
                this.chosenThumbnailStream = null;
                this.lastGivenThumbnail = null;
                this.lastGivenSegment = null;
            }
        },
        {
            key: "getLiveThumbnailStreamForWindow",
            value: function getLiveThumbnailStreamForWindow(chosenThumbnailStreamId, param) {
                var windowStart = param.windowStart;
                var _this = this;
                return _async_to_generator(function() {
                    var thumbnailStreamPromise;
                    return _ts_generator(this, function(_state) {
                        thumbnailStreamPromise = _this.thumbnailProvider.getThumbnailStream(chosenThumbnailStreamId, {
                            windowStart: windowStart
                        }).then(function(thumbnailStream) {
                            if (thumbnailStream) {
                                var _this_prefetchController;
                                (_this_prefetchController = _this.prefetchController) === null || _this_prefetchController === void 0 ? void 0 : _this_prefetchController.handleThumbnailStreamSelected(thumbnailStream);
                                _this.chosenThumbnailStream = thumbnailStream;
                                return thumbnailStream;
                            } else {
                                _this.logger.warn("handleThumbnailStreamSelected did not fetch stream");
                                return null;
                            }
                        }).catch(function(e) {
                            _this.logger.warn("getLiveThumbnailStream() failed: ".concat(e));
                            return null;
                        });
                        return [
                            2,
                            thumbnailStreamPromise
                        ];
                    });
                })();
            }
        },
        {
            key: "getSegmentForTime",
            value: function getSegmentForTime(timeIncludingAds) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_prefetchController, thumbnailStreamPromise, thumbnailStream, thumbnailSegments, segmentIndex, segmentInUse;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.lastGivenSegment && _this.checkIsInBounds(timeIncludingAds, _this.lastGivenSegment)) {
                                    return [
                                        2,
                                        _this.lastGivenSegment
                                    ];
                                }
                                if (_this.thumbnailProvider.isLive()) {
                                    thumbnailStreamPromise = _this.getLiveThumbnailStreamForWindow(_this.liveThumbnailStreamId, {
                                        windowStart: timeIncludingAds
                                    });
                                } else {
                                    thumbnailStreamPromise = Promise.resolve(_this.chosenThumbnailStream);
                                }
                                return [
                                    4,
                                    thumbnailStreamPromise
                                ];
                            case 1:
                                thumbnailStream = _state.sent();
                                if (!thumbnailStream) {
                                    return [
                                        2,
                                        Promise.resolve(null)
                                    ];
                                }
                                thumbnailSegments = thumbnailStream.thumbnailSegments;
                                segmentIndex = thumbnailSegments.findIndex(function(segment) {
                                    return segment.startPosition <= timeIncludingAds && segment.startPosition + segment.duration > timeIncludingAds;
                                });
                                segmentInUse = thumbnailSegments[segmentIndex];
                                if (!segmentInUse) {
                                    _this.logger.warn('Invalid position given. Will not return thumbnail.');
                                    return [
                                        2,
                                        Promise.resolve(null)
                                    ];
                                }
                                _this.lastGivenSegment = segmentInUse;
                                (_this_prefetchController = _this.prefetchController) === null || _this_prefetchController === void 0 ? void 0 : _this_prefetchController.handleNewSegmentRequested(segmentInUse, segmentIndex);
                                return [
                                    2,
                                    Promise.resolve(segmentInUse)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildBoundingRect",
            value: function buildBoundingRect(timeIncludingAds, segmentInUse) {
                var _this_chosenThumbnailStream = this.chosenThumbnailStream, thumbnailHeight = _this_chosenThumbnailStream.thumbnailHeight, thumbnailWidth = _this_chosenThumbnailStream.thumbnailWidth, thumbnailDuration = _this_chosenThumbnailStream.thumbnailDuration, maxHorizontalThumbnailCount = _this_chosenThumbnailStream.maxHorizontalThumbnailCount, maxVerticalThumbnailCount = _this_chosenThumbnailStream.maxVerticalThumbnailCount;
                var currentTimeInsideSegment = timeIncludingAds - segmentInUse.startPosition;
                var horizontalIndex = Math.floor(currentTimeInsideSegment / thumbnailDuration);
                var verticalIndex = Math.floor(currentTimeInsideSegment / (thumbnailDuration * maxHorizontalThumbnailCount));
                var top = thumbnailHeight * (verticalIndex % maxVerticalThumbnailCount);
                var left = thumbnailWidth * (horizontalIndex % maxHorizontalThumbnailCount);
                var right = left + thumbnailWidth;
                var bottom = top + thumbnailHeight;
                return {
                    width: thumbnailWidth,
                    height: thumbnailHeight,
                    top: top,
                    left: left,
                    right: right,
                    bottom: bottom
                };
            }
        }
    ]);
    return GenericThumbnailManager;
}(BaseThumbnailManager);

//# sourceMappingURL=generic-thumbnail-manager.js.map